const {
  verifyIfHasErrorInParams,
} = require("./src/utils/verify-errors-params");
const { CardHandler } = require("./src/card");
const { Order } = require("./src/order");
const { PaymentIntent } = require("./src/payment");
const { GetToken } = require("./src/token/token");

class ZooxPay {
  constructor(params) {
    const _hasErrors = verifyIfHasErrorInParams(params);
    if (_hasErrors) throw new Error(_hasErrors);
    this.params = params;
  }

  createCard(param) {
    return new Promise((resolve, reject) => {
      const card = new CardHandler(this.params);
      card
        .handler(this.params)
        .then((cardClass) => {
          const card = cardClass.create(param);
          resolve(card);
        })
        .catch((err) => reject(err));
    });
  }

  createCardToken(param) {
    return new Promise((resolve, reject) => {
      const card = new CardHandler(this.params);
      card
        .handler(this.params)
        .then((cardClass) => {
          const card = cardClass.createCardToken(param);
          resolve(card);
        })
        .catch((err) => reject(err));
    });
  }

  listCards() {
    return new Promise((resolve, reject) => {
      const card = new CardHandler(this.params);
      card
        .handler(this.params)
        .then((cardClass) => {
          const cards = cardClass.list();
          resolve(cards);
        })
        .catch((err) => reject(err));
    });
  }

  removeCard(cardId) {
    return new Promise((resolve, reject) => {
      const card = new CardHandler(this.params);
      card
        .handler(this.params)
        .then((cardClass) => {
          const cards = cardClass.remove(cardId);
          resolve(cards);
        })
        .catch((err) => reject(err));
    });
  }

  createPaymentIntent(params) {
    return new Promise((resolve, reject) => {
      const paymentIntent = new PaymentIntent(this.params);
      paymentIntent
        .create(params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  updatePaymentIntent(params) {
    return new Promise((resolve, reject) => {
      const paymentIntent = new PaymentIntent(this.params);
      paymentIntent
        .updateStatus(params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  listOrders(params) {
    return new Promise((resolve, reject) => {
      const order = new Order(this.params);
      order
        .list(params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  listOrderItems(params) {
    return new Promise((resolve, reject) => {
      const order = new Order(this.params);
      order
        .listItems(params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAccessToken() {
    return new Promise((resolve, reject) => {
      new GetToken(this.params)
        .get()
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}

module.exports = ZooxPay;
